import script from "./Help.vue?vue&type=script&setup=true&lang=ts"
export * from "./Help.vue?vue&type=script&setup=true&lang=ts"

import "./Help.vue?vue&type=style&index=0&id=65571cf0&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65571cf0"]])

export default __exports__